import posthog from "posthog-js";

/**
 * Returns the singleton PostHog browser client.
 * The client is initialised by the PostHogProvider component.
 */
export function getPostHogClient() {
  return posthog;
}

export default getPostHogClient;

